(function () {
  function parseLocaleNumber(v) {
    if (v == null) return NaN;
    // accetta "24,5" e "24.5"
    const s = String(v).trim().replace(/\s+/g, "").replace(",", ".");
    return parseFloat(s);
  }

  function format2(n) {
    if (isNaN(n)) return "--";
    // italiano: virgola
    return n.toFixed(2).replace(".", ",");
  }

  function initForm(form) {
    const root = form.closest("product-form-component") || form.parentElement;
    if (!root) return;

    const mqInfo = root.querySelector("[data-omnia-mq-info]");
    if (!mqInfo) return;

    const mqBox = parseFloat(mqInfo.getAttribute("data-mq-box") || "0");
    if (!mqBox || mqBox <= 0) return;

    const outMq = mqInfo.querySelector("[data-omnia-mq-total-display]");
    const outBoxes = mqInfo.querySelector("[data-omnia-boxes-display]");

    const qtyInput = form.querySelector('input[name="quantity"]');
    if (!qtyInput) return;

    const mqInput = root.querySelector("[data-omnia-mq-input]");

    function getBoxes() {
      const q = parseInt(qtyInput.value || "1", 10);
      return isNaN(q) || q < 1 ? 1 : q;
    }

    function setBoxes(boxes) {
      const b = Math.max(1, parseInt(boxes, 10) || 1);
      qtyInput.value = String(b);

      // trigger eventi per far reagire il tema
      qtyInput.dispatchEvent(new Event("input", { bubbles: true }));
      qtyInput.dispatchEvent(new Event("change", { bubbles: true }));
    }

    function updateFromBoxes() {
      const boxes = getBoxes();
      const mqTot = boxes * mqBox;

      if (outBoxes) outBoxes.textContent = String(boxes);
      if (outMq) outMq.textContent = format2(mqTot);

      // allinea anche il campo m², se esiste
      if (mqInput) mqInput.value = format2(mqTot);
    }

    function updateFromMq() {
      if (!mqInput) return;

      const wantedMq = parseLocaleNumber(mqInput.value);
      if (isNaN(wantedMq) || wantedMq <= 0) {
        // se vuoto o 0, non forzare: rimetti valori coerenti con qty
        updateFromBoxes();
        return;
      }

      const boxes = Math.max(1, Math.ceil(wantedMq / mqBox));
      setBoxes(boxes);        // questo farà aggiornare anche il tema
      updateFromBoxes();      // e aggiorna la riga Totale
    }

    // iniziale
    updateFromBoxes();

    // quando l’utente scrive i m²
    if (mqInput) {
      mqInput.addEventListener("input", updateFromMq);
      mqInput.addEventListener("change", updateFromMq);
    }

    // se il tema cambia quantità da qualche parte (pulsanti +/- o logiche interne)
    qtyInput.addEventListener("input", updateFromBoxes);
    qtyInput.addEventListener("change", updateFromBoxes);

    // sicurezza: prima del submit riallinea
    form.addEventListener("submit", () => {
      // se l’utente ha scritto m², ricalcola confezioni
      if (mqInput && mqInput.value) updateFromMq();
      else updateFromBoxes();
    });

    // fallback leggero: se il tema aggiorna qty senza eventi
    let last = qtyInput.value;
    setInterval(() => {
      if (qtyInput.value !== last) {
        last = qtyInput.value;
        updateFromBoxes();
      }
    }, 300);
  }

  function initAll() {
    document.querySelectorAll('form[action^="/cart/add"]').forEach(initForm);
  }

  document.addEventListener("DOMContentLoaded", initAll);
  document.addEventListener("shopify:section:load", initAll);
})();

